import { fitBounds } from 'google-map-react'
import {
  getMarketsByBounds,
  formatLocationObject,
  checkForBoundsAddressType,
  getBounds,
  getMapStateAndMarketsForLocation,
  checkForLargeBounds
} from '../'

export const setMarketsMapStateWithAddress = async (
  address,
  token,
  mapState
) => {
  const location = formatLocationObject(
    address.geometry.location,
    'GOOGLE_MAPS'
  )
  const addressBounds = getBounds(address.geometry.bounds, 'GOOGLE_MAPS')
  const isExactSearch = address?.geometry?.location_type === 'ROOFTOP'

  const hasLargeBounds = checkForLargeBounds(addressBounds)
  const isBoundsAddressType = checkForBoundsAddressType(address)

  if (isBoundsAddressType && hasLargeBounds && addressBounds) {
    const { result: marketsByBounds } = await getMarketsByBounds(
      addressBounds,
      location,
      token
    )

    if (marketsByBounds.length > 0) {
      const { zoom } = fitBounds(addressBounds, mapState.size)

      return {
        mapState: {
          ...mapState,
          center: location,
          zoom: marketsByBounds.length <= 6 ? 11 : zoom,
          location,
          addressBounds
        },
        markets: marketsByBounds,
        isExactSearch
      }
    }
  }

  const { mapState: newMapState, markets: marketsForLocation } =
    await getMapStateAndMarketsForLocation(location, token, mapState)

  return {
    mapState: {
      ...mapState,
      ...newMapState,
      center: newMapState.location,
      zoom: isExactSearch ? 13 : newMapState.zoom
    },
    markets: marketsForLocation,
    isExactSearch
  }
}
